/**
 * GNB 검색 UI 소속을 표시하는 DOM 마커
 *
 * GNB는 반응형 nav 3벌(Desktop/Tablet/Mobile)을 모두 렌더한 뒤 CSS로 숨기므로
 * 검색창 인스턴스가 항상 2개 이상 동시에 마운트된다.
 * 반면 열림 상태(isOpen)는 Zustand 스토어 하나로 공유된다.
 *
 * 이때 외부 클릭 판정을 인스턴스 로컬 ref(containerRef.contains)로 하면
 * 보이는 검색창을 클릭해도 숨겨진 인스턴스가 "내 박스 밖"으로 판정해 닫아버린다.
 * 마커로 판정하면 어느 인스턴스가 계산해도 같은 답이 나오므로 중복이 무해해진다.
 *
 * 검색 UI의 최상위 컨테이너에 SEARCH_UI_MARKER_PROPS를 전개해 마커를 부여한다.
 */ const SEARCH_UI_MARKER = "data-gnb-search";
/** 검색 UI 컨테이너에 전개해 마커를 부여한다 */ export const SEARCH_UI_MARKER_PROPS = {
    [SEARCH_UI_MARKER]: ""
};
/** 클릭 지점이 검색 UI 내부인지 판정하는 셀렉터 */ export const SEARCH_UI_SELECTOR = "[".concat(SEARCH_UI_MARKER, "]");
/**
 * 클릭 지점이 검색 UI(마커가 붙은 컨테이너) 내부인지 판정
 * 인스턴스와 무관하게 동일한 결과를 반환한다
 */ export const isInsideSearchUI = (target)=>target instanceof Element && !!target.closest(SEARCH_UI_SELECTOR);
